const freeRoutes = ['Home'];

const hasAccessSection = (routes = [], name = '') => {
    const sections = routes.filter(item => {
            return item.includes('.*');
        })
        .map(item => {
            return item.split('.*')[0];
        });

    const routeSection = name.split('.')[0];

    return sections.indexOf(routeSection) > -1
};

const hasAccessRoute = (routes = [], name = '') => {
    const simpleRoutes = routes.filter(item => {
            return !item.includes('*');
        });

    return simpleRoutes.indexOf(name) > -1
};

export default function access (context){
    const { from, to, next, store, router } = context;
    const { user } = store.getters;

    if ( user.role.is_super || user.role.routes.find(item => item === '*') || freeRoutes.find(item => item === to.name))
        return next();

    if(hasAccessSection(user.role.routes, to.name) || hasAccessRoute(user.role.routes, to.name))
        return next();

    const access = store.getters.access;
    access.showModal = true;
    store.commit('setAccess', access);
}
